import * as config from 'show-index/constants/config';
import Show from 'show-index/models/show';
import Video from 'common/models/video';
import { action, asStructure, computed, extendObservable, observable } from 'mobx';
import { noop, sortBy, uniq } from 'lodash';


const DisplayMode = {
    ALL: 0,
    SEARCH: 1,
    LETTER: 2
};


class ShowsStore {
    @observable notification = asStructure({ title: config.DEFAULT_NOTIFICATION_TITLE });
    @observable searchInputValue = '';
    @observable selectedLetter = null;
    @observable shows = [];

    constructor(props) {
        (props.shows || []).forEach(this.addShow);
        this.fetchNotificationInterval = setInterval(this.fetchNotification, 15000);
        this.fetchNotification();
        this.stream = new Video(props.stream);
        extendObservable(this, {
            featuredShows: props.featured_shows || []
        });
    }

    destroy() {
        this.removeAllShows();
        clearInterval(this.fetchNotificationInterval);
        this.fetchNotificationInterval = null;
    }

    fetchNotification = () => {
        return fetch(config.NOTIFICATIONS_ENDPOINT)
            .then(res => res.json())
            .then(json => this.setNotification(json.data))
            .catch(noop);
    };

    /*=======================================
    =            Computed Values            =
    =======================================*/

    @computed get displayMode() {
        if (this.searchInputValue && this.searchInputValue.length >= config.MIN_SEARCH_LENGTH) {
            return DisplayMode.SEARCH;
        } else if (this.selectedLetter) {
            return DisplayMode.LETTER;
        }
        return DisplayMode.ALL;
    }

    @computed get filterRegex() {
        return new RegExp(this.searchInputValue, 'i');
    }

    @computed get filteredShows() {
        switch (this.displayMode) {
            case DisplayMode.SEARCH :
                return this.showsByTitle.filter(({ title }) => this.filterRegex.test(title));
            case DisplayMode.LETTER :
                return this.showsByTitle.filter(({ firstLetter }) => firstLetter === this.selectedLetter);
            default:
                return this.showsByTitle;
        }
    }

    @computed get letters() {
        return uniq(this.shows.map(show => show.firstLetter)).sort();
    }

    @computed get showsByTitle() {
        return sortBy(this.shows, 'sortableTitle');
    }

    /*===============================
    =            Actions            =
    ===============================*/

    @action addShow = (props) => {
        this.shows.push(new Show(this, props));
    };

    @action removeAllShows = () => {
        this.shows = [];
    };

    @action selectLetter = (letter) => {
        this.selectedLetter = letter;
    };

    @action setNotification = (data) => {
        data = data || {};
        data.title = data.title || config.DEFAULT_NOTIFICATION_TITLE;
        this.notification = data;
    };

    @action setSearchInputValue = (value) => {
        this.searchInputValue = (typeof value === 'string' && value.trim()) ? value : '';
    };

}


export default ShowsStore;



// WEBPACK FOOTER //
// ./src/show-index/stores/shows.js